export default __webpack_public_path__ + "static/media/noa-6.780b8d0c.jpg";